import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import InformationLink from './InformationLink'

interface Props {
  employeeId: string
  companyId: string
  legalEntityId: string
}

const LegalEntityLinks = ({ employeeId, companyId, legalEntityId }: Props) => {
  const { navigation } = useNavigation()
  return (
    <>
      <InformationLink
        href={`${navigation.employees.id.personal.fullPath({
          id: employeeId,
        })}?switchToCompanyId=${companyId}`}
        label={i18n.t('bookkeepers.incidence.details.see_employee_profile')}
      />
      <InformationLink
        href={`${navigation.employees.id.contractVersions.fullPath({
          id: employeeId,
        })}?switchToCompanyId=${companyId}`}
        label={i18n.t('bookkeepers.incidence.details.see_employee_contract')}
      />
      <InformationLink
        href={`${navigation.settings.legalEntitiesId.fullPath({
          id: legalEntityId,
        })}?switchToCompanyId=${companyId}`}
        label={i18n.t('bookkeepers.incidence.details.see_legal_entity')}
      />
    </>
  )
}

export default LegalEntityLinks
